import { AppNotificationDto } from '@act/shared/data-transfer-objects';
import { EntityState } from '@reduxjs/toolkit';

/**
 * List notifications from the entity adapter without assuming id bookkeeping is hydrated.
 * Safe when `appNotificationIds` is still null (initial load / websocket-before-fetch).
 *
 * @param adapterState - Entity adapter state for app notifications, if present.
 * @returns Notification DTOs currently in the store.
 */
export function selectAppNotificationListFromAdapter(
  adapterState: EntityState<AppNotificationDto, number> | null | undefined
): AppNotificationDto[] {
  if (!adapterState?.entities) {
    return [];
  }

  return Object.values(adapterState.entities).filter(
    (notification): notification is AppNotificationDto => notification != null
  );
}
